
























import {
  Vue,
  Component
} from "@/shared/vuepack";

import HealthcareExpenseNavigationV2 from "@/employee/components/healthcareExpenseV2/HealthcareExpenseNavigationV2.vue";
import HealthcareExpensesUnreimbursed from "@/employee/components/healthcareExpenseV2/HealthcareExpensesUnreimbursed.vue";
import HealthcareExpensesReimbursed from "@/employee/components/healthcareExpenseV2/HealthcareExpensesReimbursed.vue";
import HealthcareExpensesAdd from "@/employee/components/healthcareExpenseV2/HealthcareExpensesAdd.vue";
import SideBar from "@/employee/components/healthcareExpenseV2/SideBar.vue";
import { useExpenseStore } from "@/employee/store/expense";

@Component({
  components: {
    HealthcareExpenseNavigationV2,
    HealthcareExpensesUnreimbursed,
    HealthcareExpensesReimbursed,
    HealthcareExpensesAdd,
    SideBar,
  },
})
export default class EligibleExpenses extends Vue {
  expenseStore = useExpenseStore();
  showExpenseAddView = false;

  mounted (): void {
    this.expenseStore.getImportedExpenses();
    this.$on("tab-clicked", (event, tab) => {
      this.showExpenseAddView = false;
    });

    this.$on("close-add-expense", event => {
      this.showExpenseAddView = false;
    });
  }

  onAddClick (event: any) {
    event.preventDefault();
    this.showExpenseAddView = !this.showExpenseAddView;
  }

  get displayPilotExpenseTracker () {
    return this.expenseStore.importedExpenses.length > 0;
  }
}
